import { render } from "./ArtifactChangeInput.vue?vue&type=template&id=7c9ac9da&scoped=true&ts=true"
import script from "./ArtifactChangeInput.vue?vue&type=script&lang=ts"
export * from "./ArtifactChangeInput.vue?vue&type=script&lang=ts"

import "./ArtifactChangeInput.vue?vue&type=style&index=0&id=7c9ac9da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c9ac9da"]])

export default __exports__